<template>
  <div class="formAbstraction">
    <form-abstraction
      :schema="schema"
      :model.sync="model"
      :error.sync="error"
      :onSubmit="onSubmit"
      :wrapper="wrapper" />
  </div>
</template>
<script>
import FormAbstraction from '@/components/Form'
import types from '@/lib/types'
const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

export default {
  name: 'adx-form-abstraction-doc',
  components: {
    'form-abstraction': FormAbstraction
  },
  data(){
    return {
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        email: `test@gmail.com`,
        firstName: `Test`,
        lastName: `Coba`,
        password: `asdfqwer`,
        // agreement: true,
        // job: `student`,
        comment: `cobacoba dulu`,
        // gender: `female`,
        // location: [`jakarta`, `bandung`]
      },
      error: {
        // email: `Backend Error`,
        // agreement: `Must Be Checked`,
        job: `Must Not Student`,
        // comment: `Not Valid Input`,
        // gender: `not picked`
      },
      onSubmit: {
        wrapper: {
          class: `button-group inline`
        },
        buttons: [
          {
            type: BUTTON,
            action: SUBMIT,
            label: `Register`,
            uri: `forms/1`,
            // params: {id:`2`},
            method: `put`, // HTTP Method
            class: `btn-regular primary`,
            isLoading: false
          },
          {
            type: RESET,
            label: `Reset`,
            class: `btn-regular warning`,
            isLoading: false
          },
          {
            type: BUTTON,
            action: GOTO, // API Call
            label: `Others`,
            uri: `typography`,
            class: `btn-regular secondary`,
            isLoading: false
          }
        ]
      },
      schema: [
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Email',
              model: 'email',
              method: 'onChange', // onBlur / onChange
              validation: ['NotEmpty', 'Email']
            }
          ]
        },
        {
          type: 'inline',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'First Name',
              model: 'firstName',
              validation: ['NotEmpty', 'MinLength:6']
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Last Name',
              model: 'lastName',
              validation: ['NotEmpty', 'MinLength:6']
            },
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'password',
              label: 'Password',
              model: 'password',
              validation: ['NotEmpty', 'MinLength:6']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'checkbox',
              label: 'Agree',
              model: 'agreement',
              validation: ['Checked']
            },
          ]
        },
        {
          type: 'inline',
          fields: [
            {
              type: 'multiple-checkbox',
              label: 'Location',
              model: 'location',
              validation: ['NotEmpty'],
              options: [
                {
                  label: 'Jakarta',
                  value: 'jakarta'
                },
                {
                  label: 'Bandung',
                  value: 'bandung'
                },
                {
                  label: 'Bali',
                  value: 'bali'
                }
              ]
            }
          ]
        },
        {
          type: 'inline',
          fields: [
            {
              type: 'radio',
              model: 'gender',
              label: 'Gender',
              validation: ['NotEmpty'],
              options: [
                {
                  label: 'Male',
                  value: 'male',
                },
                {
                  label: 'Female',
                  value: 'female',
                },
                {
                  label: 'Rather Not Say',
                  value: 'rather_not_say',
                }
              ]
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'selectdropdown',
              label: 'Job',
              model: 'job',
              validation: ['NotEmpty'],
              options: [
                {
                  label: 'Entrepreneur',
                  value: 'entrepreneur'
                },
                {
                  label: 'Student',
                  value: 'student'
                },
                {
                  label: 'Anak Kosan',
                  value: 'anakkosan'
                },
              ]
            },
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'textarea',
              label: 'Comment',
              model: 'comment',
              method: 'onChange',
              validation: ['NotEmpty', 'MinLength:6']
            },
          ]
        },
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>